import { Button, Col, Form, Image, Input, InputNumber, Row } from 'antd'
import React from 'react'

import LN from 'utils/language';
import { useEffect } from 'react';

// import { loginw,onChangeAuth} from '@/redux/actions/auth/index';
import { useDispatch } from 'react-redux';
import { login, onChangeAuth } from 'page/auth/redux'
import style from './login.module.scss'
import { useRedux } from 'redux/useRedux';
import LoginLogic from './login_logic';
import CustomDatePicker from 'component/DatePickerComponent/CustomDatePicker';
import { EyeHiddenIcon, EyeIcon, LoginIcon } from 'assets/svgComponent';
const Login = () => {
    const { formLogin, finish } = LoginLogic()
    const { dispatch, authState } = useRedux()


    return (
        <>
            <Row align={"middle"}>
                <LoginIcon className={style.logoIcon} />
                <p className='t1 white100 ms10 '  >ورود</p>
            </Row>
            <p className='t7 white100 mt10 mb40 '  >اینوستو همراه همیشگی شما در سرمایه گذاری مطمئن در هر مکان و هر زمان.</p>
            <Form
                form={formLogin}
                layout="vertical"
                className={["customForm"].join(" ")}
                onFinish={() => finish()}
            >
                <Row justify={"start"} className="fullWidth" >
                    <Form.Item label={'شماره همراه'} name="username" rules={[{
                        validator(_, value) {
                            var reg = /^\d+$/;
                            if (!reg.test(value)) return Promise.reject("شماره همراه باید اعداد لاتین باشد");
                            if (!value || value.toString().length > 11) return Promise.reject("شماره همراه معتبر نیست");
                            if (value.toString().length == 11) return Promise.resolve();
                        }
                    }]}>
                        <Input className='customInput' placeholder={'شماره همراه'} />
                    </Form.Item>
                    {/* <Form.Item label={"رمز عبور"} name="password" rules={[{ required: true, message: LN.required }]}>
                        <Input.Password iconRender={(visible) => (!visible ? <EyeHiddenIcon /> : <EyeIcon />)} className='customInput' type={"password"} placeholder={"رمز عبور"} />
                    </Form.Item> */}
                    {/* <p className='t6 primary mt10 mb50 pointer '  onClick={()=>dispatch(onChangeAuth("status","forgetPassword"))} >رمز عبور را فراموش کردم</p> */}
                    {/* <Button className='fillButton mt40' htmlType='submit' loading={authState.loginLoading} > ورود</Button> */}
                    {/* <Row justify={"center"} className={"fullWidth"} >
                        <p className='t5 white100 mt10   '  >هنوز عضو اینوستو نیستی؟!</p>
                        <p onClick={()=>dispatch(onChangeAuth("status","signUp"))} className='t5 primary mt10 ms10  pointer '  >همین امروز عضو شو</p>
                    </Row> */}

                </Row>
                    <Row justify={"space-between"}>
                        <Col xs={6}>
                            <Button
                                className='opacityButton  mt40 ' style={{ width: "100%", borderRadius: "15" }} >
                                <Col>
                                    <span>قوانین</span>
                                    <p> <span>اینوستو</span></p>
                                </Col>
                            </Button>
                        </Col>
                        <Col xs={17}>
                            <Button
                                className='fillButton mt40 ' htmlType='submit' loading={authState.loginLoading} > ورود</Button>
                        </Col>
                    </Row>

            </Form>
        </>
    )
}

export default Login
